import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor - attach token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('pdfedit_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor - handle auth errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pdfedit_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data)
};

// PDF API
export const pdfAPI = {
  upload: (formData) => api.post('/pdf/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => formData._onProgress?.(Math.round((e.loaded * 100) / e.total))
  }),
  getDocuments: (params) => api.get('/pdf/documents', { params }),
  getDocument: (id) => api.get(`/pdf/documents/${id}`),
  downloadFile: (id) => api.get(`/pdf/documents/${id}/file`, { responseType: 'blob' }),
  save: (id, data) => api.post(`/pdf/documents/${id}/save`, data),
  uploadImage: (formData) => api.post('/pdf/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  export: (id, format) => api.post(`/pdf/documents/${id}/export`, { format }),
  delete: (id) => api.delete(`/pdf/documents/${id}`)
};

// Subscription API
export const subscriptionAPI = {
  getPlans: () => api.get('/subscriptions/plans'),
  createCheckout: (planId) => api.post('/subscriptions/create-checkout', { planId }),
  getPortal: () => api.post('/subscriptions/portal'),
  getStatus: () => api.get('/subscriptions/status')
};

// User API
export const userAPI = {
  updateProfile: (data) => api.put('/user/profile', data),
  changePassword: (data) => api.put('/user/password', data),
  getDashboard: () => api.get('/user/dashboard'),
  deleteAccount: () => api.delete('/user/account')
};

export default api;
